import { compress } from "micro-graphql-react"

export default compress`
  query($parentId: ID!) {
    parent(id: $parentId) {
      students {
        id
        fullName
        safeEmail
        editPath
        showPath
        subjects {
          id
          name
        }
      }
    }
  }
`
